import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ExcelService } from '../excel.service';
import { AuthService } from '../auth.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-manage-size',
  templateUrl: './manage-size.component.html',
  styleUrls: ['./manage-size.component.scss'],
})
export class ManageSizeComponent {
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  } 
  items:any=[];
  displayedColumns = ['PurchaseCategory','Product','Code','Size','delete'];
  dataSource: any; 
  cardView;
  loader:boolean=true;
  fontStyle;
  search:any=[];
  editId;
  excelData: any = [];
  productName;
  productId;
  productObj:any;
  category;
  cateName;
  cateId;

  constructor(public service:ApiService, 
              public handler:HandlerService,
              public platform:Platform,
              public translate: TranslateService,
              public router:Router, private excelService: ExcelService,
              public auth:AuthService) { }

  ionViewWillEnter() {
    this.fontStyle = localStorage.getItem('lang')
    if (this.platform.ANDROID || this.platform.IOS) {
      this.cardView = 'true';
    }
    else{
      if(localStorage.getItem('config')){
        var con = JSON.parse(localStorage.getItem('config'));
        let y = con.find(res => res.shortCdConst == "DFLTCARDLYT");
        if(y){
          this.cardView=y.userValue;
        }
        else{
          this.cardView = 'true';
        }
       
      }
    }

    this.getProductObject();
   
  }

  getProductObject(){
    this.loader=true;
    this.service.getAllProduct().subscribe(res => {
      this.productObj = res;
   this.getCategory();
    })
  }

  
  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.getAllSize();
     })
  }
  getAllSize(){
    this.service.getAllsize().subscribe(res=>{
      if(res){
        this.items = res;
        this.items.map(dat=>{
          this.category.map(dat1 => {
            if (dat1.id == dat.purchaseCategoryId) {
              Object.assign(dat, { cateName: dat1.name })
            }
        })
          })
          this.items.map(dat=>{
            this.productObj.map(dat1 => {
              if (dat1.id == dat.productId) {
                Object.assign(dat, { productName: dat1.name })
              }
          })
            })
        this.dataSource = new MatTableDataSource(this.items);
      }
      this.loader = false;
    },err=>{
      this.loader = false;
      this.handler.err(err)
    })
  }
  edit(id){
    this.router.navigate(['/edit-size',id]);
  }
  deletesize(id){
    this.loader=true;
    this.service.deletesize(id).subscribe(res=>{
      this.ionViewWillEnter()
     this.loader=false;
      this.handler.res("Deleted successfully")
   
 
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }
  viewChange(id) {
    if (id == 1) { this.cardView = 'true'; }
    else {this.cardView = 'false'; }
  }
  exportAsXLSX(): void {
    this.items.map(res => {
      this.excelData.push({
        Purchase_Category: res.cateName, Product: res.productName,Code:res.code,Size:res.name
      })
    })
    this.excelService.exportAsExcelFile(this.excelData, 'Size');
  }
  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }
  ionViewWillLeave(){
    this.search = "";
  }
  clear(){
    this.search="";
  }

}


